import { render, staticRenderFns } from "./build_mhh_3_call_button_dashboard.vue?vue&type=template&id=28f47979&scoped=true"
import script from "./build_mhh_3_call_button_dashboard.vue?vue&type=script&lang=js"
export * from "./build_mhh_3_call_button_dashboard.vue?vue&type=script&lang=js"
import style0 from "./build_mhh_3_call_button_dashboard.vue?vue&type=style&index=0&id=28f47979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f47979",
  null
  
)

export default component.exports